import { Component, OnInit, Input } from '@angular/core';
import { faPlus, faTrashAlt, faHistory, faClipboard } from '@fortawesome/pro-light-svg-icons';
import { CaseService } from '../../../shared/services/case.service';
import { AuthService } from '../../../auth/auth.service';
import { Subscription } from 'rxjs';
import { AddCaseOverviewItemComponent } from './add-case-overview-item/add-case-overview-item.component';
import { CaseOverviewHistoryComponent } from './case-overview-history/case-overview-history.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { YesNoPopupComponent } from 'src/app/shared/components/yes-no-popup/yes-no-popup.component';
import { ModalService } from 'src/app/shared/services/modal.service';

@Component({
  selector: 'app-case-overview',
  templateUrl: './case-overview.component.html',
  styleUrls: ['./case-overview.component.scss']
})
export class CaseOverviewComponent implements OnInit {

  @Input() caseId: number;

  viewInit = false;
  items: any;

  faPlus = faPlus;
  faTrashAlt = faTrashAlt;
  faHistory = faHistory;
  faClipboard = faClipboard;

  refreshSubscription: Subscription;

  constructor(
  public activeModal: NgbActiveModal,
  private caseService: CaseService,
  public authService: AuthService,
  public modalService: ModalService) {

    this.refreshSubscription = this.caseService.refreshCaseOverviewObservable.subscribe(() => {
      this.loadCaseOverview();
    });

  }


  ngOnInit(): void {
  }

  ngAfterContentInit() : void {
    this.viewInit = true;
    this.loadCaseOverview();
  }

  loadCaseOverview(){

    if (!this.viewInit) return;

    this.caseService.getCaseOverviewItems(this.caseId).subscribe(result => {
      this.items = result;
    }, error => {

      var errorMessage = "Failed to get items";
      if (error.error !== null && error.error.message !== undefined) {
        errorMessage = error.error.message;
      }

    });
  }

  addOverviewItem(){

    const modalRef = this.modalService.openWithOptions(AddCaseOverviewItemComponent, {size: 'lg'});
              
    modalRef.componentInstance.caseId = this.caseId;

    modalRef.result.then(
      (result) => {
        if(result)
        {
            this.loadCaseOverview();
        }
    },
      () => {} // dismissed - do nothing
    );

  }

  removeOverviewItem(id: number){

    const modalRef = this.modalService.openWithOptions(YesNoPopupComponent, {size: 'lg'});
              
    modalRef.componentInstance.messageHeader = 'Are you sure you want to remove this item?';
    modalRef.componentInstance.popupText1 = '';
    modalRef.componentInstance.popupText2 = '';

    modalRef.result.then(
      (result) => {

        if(result)
        {
            this.caseService.deleteCaseOverviewItem(this.caseId, id).subscribe(result => {
            this.loadCaseOverview();
          });
        }

    },
      () => {} // dismissed - do nothing
    );
  }

  viewHistory(){
    const modalRef = this.modalService.openWithOptions(CaseOverviewHistoryComponent, {size: 'xl'});
    modalRef.componentInstance.caseId = this.caseId;
  }

  ngOnDestroy(){
    if (this.refreshSubscription) {
      this.refreshSubscription.unsubscribe();
    }
  }

}
